module.exports = __webpack_public_path__ + "public/Icons/edit.png?f91744ec";